// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CfLj","right":"styles_right__3R-Xd"};